export default function ClipNavIcon({ fill = "#94A3B8" }) {
	return (
		<svg width={28} height={28} viewBox="0 0 24 24" fill="none" aria-hidden>
			<rect x="3" y="6" width="13" height="12" rx="2.5" fill={fill} fillOpacity={0.22} />
			<rect x="3" y="6" width="13" height="12" rx="2.5" stroke={fill} strokeWidth="1.2" />
			<path d="M16.5 10.2 20 12l-3.5 1.8V10.2Z" fill={fill} />
		</svg>
	);
}
